import { createContext, useEffect, useReducer } from "react";
import NotifReducer from "./notifReducer";

const INITIAL_STATE = {
  user: "flex@flex.al",
  isFetching: true,
  error: false,
  notificationsArr: [],
};

export const NotifContext = createContext(INITIAL_STATE);

export const NotifContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(NotifReducer, INITIAL_STATE);

  // Live WS notifications (dispatched from AuthenticatedRoute)
  useEffect(() => {
    const onNotif = (event) => {
      const body = event?.detail || {};
      dispatch({
        type: "ADD_NOTIF",
        payload: {
          ...body,
          notificationId:
            body.entityId ||
            body.notificationId ||
            `ws-${body.createdAt || Date.now()}`,
          notificationTitle: body.title || body.notificationTitle || "Njoftim",
          notificationBody: body.message || body.notificationBody || "",
          notificationUrl: body.url || "/kryefaqja",
          createdAt: body.createdAt || Date.now(),
          notificationMarkedRed: false,
          notificationMarkedHidden: false,
          notificationMarkedDeleted: false,
        },
      });
    };
    window.addEventListener("flexhr:notification", onNotif);
    return () => window.removeEventListener("flexhr:notification", onNotif);
  }, []);

  return (
    <NotifContext.Provider
      value={{
        user: state.user,
        isFetching: state.isFetching,
        error: state.error,
        notificationsArr: state.notificationsArr,
        dispatch,
      }}
    >
      {children}
    </NotifContext.Provider>
  );
};
